import { render, staticRenderFns } from "./topicReading.vue?vue&type=template&id=622a4e55&scoped=true&"
import script from "./topicReading.vue?vue&type=script&lang=js&"
export * from "./topicReading.vue?vue&type=script&lang=js&"
import style0 from "./topicReading.vue?vue&type=style&index=0&id=622a4e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a4e55",
  null
  
)

export default component.exports